var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "control-user",
      on: { mouseenter: _vm.showDropdownUser, mouseleave: _vm.hideDropdownUser }
    },
    [
      _c(
        "div",
        { staticClass: "icon", on: { click: _vm.iconClick } },
        [
          _c("f-sprite-icon", {
            attrs: { "icon-link": _vm.$options.icons.IconUser.id }
          }),
          _vm.LOGGED_IN
            ? _c("ui-badge", {
                attrs: {
                  text: _vm.bonuses,
                  color: "#95D4E9",
                  "max-width": "50"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "dropdown" },
        [
          _c(
            "ui-dropdown",
            {
              attrs: {
                visible: _vm.dropDownVisible,
                "overlay-height": "40",
                right: ""
              },
              on: {
                "on-close": function($event) {
                  _vm.dropDownVisible = false
                }
              }
            },
            [
              _c("ul", { staticClass: "control-user-account" }, [
                _c("li", [
                  _c("a", { attrs: { href: "/account" } }, [
                    _vm._v("Профиль"),
                    _c("span", [_vm._v(_vm._s(_vm.ACCOUNT.firstName))])
                  ])
                ]),
                _c("li", [
                  _c("a", { attrs: { href: "/account/orders" } }, [
                    _vm._v("Заказы")
                  ])
                ]),
                _c("li", [
                  _c("a", { attrs: { href: "/account/addresses" } }, [
                    _vm._v("Адреса")
                  ])
                ]),
                _c("li", [
                  _c("a", { attrs: { href: "/account/subscribes" } }, [
                    _vm._v("Подписки")
                  ])
                ]),
                _c("li", [
                  _c(
                    "a",
                    { attrs: { href: "/account/club" } },
                    [
                      _vm._v("Клубная программа"),
                      _c("ui-badge", {
                        attrs: {
                          text: _vm.bonusesWithText,
                          size: "large",
                          color: "#95D4E9",
                          "max-width": "100"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c("li", [
                  _c(
                    "a",
                    { attrs: { href: "/account/logout" } },
                    [
                      _vm._v("Выход"),
                      _c("f-sprite-icon", {
                        attrs: { "icon-link": _vm.$options.icons.IconExit.id }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }